//
//
//------------------------ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ROTA de PRODUCAO ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼  
export const rotaDeProducaoPadrao = "https://analytics-api.dalcatech.com.br/cardapio/v3"; // PRESTAR ATENCAO na versao v2 ou v3 !!!!
// export const rotaDeProducaoPadrao = "https://api-teste.dalcatech.com.br/cardapio/v3"; // PRESTAR ATENCAO na versao v2 ou v3 !!!!
// export const rotaDeProducaoPadrao = "http://192.168.100.233:8000/cardapio/v3"; // PRESTAR ATENCAO na versao v2 ou v3 !!!!

//
//------------------------ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ROTA de PRODUCAO HARD ROCK ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼
export const rotaDeProducaoHardRockPortoAlegre = "https://hrcpoa.dalcatech.com.br/cardapio/v3";
export const rotaDeProducaoHardRockCuritiba = "https://hrccwb.dalcatech.com.br/cardapio/v3";
export const rotaDeProducaoIpFixoDalca = "https://ipfixo.dalcatech.com.br/cardapio/v3";
export const rotaDeProducaoMonteCarlo = "https://montecarlo.dalcatech.com.br/cardapio/v3";
export const rotaDeProducaoHardRockGramado = "https://hrcgramado.dalcatech.com.br/cardapio/v3";
export const rotaDeProducaoHardRockPraiaGrande = "https://hrcpraiagrande.dalcatech.com.br/cardapio/v3";

export const rotaDeProducaoHardRockItapema = "https://hrcitapema.dalcatech.com.br/cardapio/v3";
export const rotaDeProducaoHardRockFloripa = "https://hrcfloripa.dalcatech.com.br/cardapio/v3";




//
// ---------------------------- ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ROTA de TESTE ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ --------------------------------------
// export const rotaDeProducaoPadrao = "http://192.168.100.231:8000/cardapio/v3"; //PRESTAR ATENCAO no ip desta maquina!!!
// export const rotaDeProducaoPadrao = "https://ipfixo.dalcatech.com.br/cardapio/v3";
//
// PRESTAR ATENCAO no ip desta maquina!!! 
// export const rotaDeProducaoPadrao = "http://192.168.100.28:8000/cardapio/v2";

export const VERSAO = "8.4.0"; // IMPORTANT! lembrar disso aqui que vai na rota buscaritens
// export const VERSAO = "1.0.0"; // IMPORTANT! lembrar disso aqui que vai na rota buscaritens

/** indica se devemos usar rota do hard rock */
var rotaFinal = null;

export function setarUsarRotaHardRockPortoAlegre() {
  rotaFinal = "poa";
}
export function setarUsarRotaHardRockCuritiba() {
  rotaFinal = "cwb";
}
export function setarUsarIpFixoDalca() {
  rotaFinal = "ipfixo";
}
export function setarUsarRotaMontecarlo() {
  rotaFinal = "montecarlo";
}
export function setarUsarRotaHardRockGramado() {
  rotaFinal = "hrcgramado";
}
export function setarUsarRotaHardRockPraiaGrande() {
  rotaFinal = "hrcpraiagrande";
}
export function setarUsarRotaHardRockItapema() {
  rotaFinal = "hrcitapema";
}
export function setarUsarRotaHardRockFloripa() {
  rotaFinal = "hrcfloripa";
}




/**
 * Alterna entre rota padrao ou rota HardRocK (pq  eles usam ip fixo)
 * @returns {String} rota
 */
export const rotaDeProducao = () => {
  if (rotaFinal === "poa") {
    console.log("%c usando rota de hard rock POA", "background: red");
    return rotaDeProducaoHardRockPortoAlegre;
  }
  if (rotaFinal === "cwb") {
    console.log("%c usando rota de hard rock CWB", "background: red");
    return rotaDeProducaoHardRockCuritiba;
  }
  if (rotaFinal === "ipfixo") {
    console.log("%c usando rota de ipfixo da dalca", "background: red");
    return rotaDeProducaoIpFixoDalca;
  }
  if (rotaFinal === "montecarlo") {
    console.log("%c usando rota de montecarlo da dalca", "background: red");
    return rotaDeProducaoMonteCarlo;
  }
  if (rotaFinal === "hrcgramado") {
    console.log("%c usando rota de hrc gramado da dalca", "background: red");
    return rotaDeProducaoHardRockGramado;
  }
  if (rotaFinal === "hrcpraiagrande") {
    console.log("%c usando rota de hrc praiagrande da dalca", "background: red");
    return rotaDeProducaoHardRockPraiaGrande;
  }
  if (rotaFinal === "hrcitapema") {
    console.log("%c usando rota de hrc itapema da dalca", "background: red");
    return rotaDeProducaoHardRockItapema;
  }
  if (rotaFinal === "hrcfloripa") {
    console.log("%c usando rota de hrc floripa da dalca", "background: red");
    return rotaDeProducaoHardRockFloripa;
  }
  console.log("%c usando rota padrao", "background: green");
  return rotaDeProducaoPadrao;
};
